import { useState, useCallback } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Stack,
} from '@chakra-ui/react';
import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import { invoiceFormatList } from '../../constants';
import InvoiceFormatFields from '../../../../sharedComponents/billing/InvoiceFormatFields'; // Update path if needed
import { getBillingFieldPaths, getBillingSettings } from '../../constants';
import { useCompanyForm } from '../../hooks/useCompanyForm';

const CompanyBillingInvoiceFormat = ({
    errors,
    touched,
    billingState,
    organisationMode,
}) => {
    const { formData, updateFormData } = useCompanyForm();

    const setBillingState = useCallback(
        (payload) => {
            updateFormData(getBillingFieldPaths(organisationMode).SETTINGS, {
                ...getBillingSettings(formData, organisationMode),
                ...payload,
            });
        },
        [organisationMode, updateFormData, formData],
    );
    const [globalCursorPosition, setGlobalCursorPosition] = useState({});

    return (
        <AccordionItemHandler
            index={0}
            key="companyBillingInvoiceFormat"
            label="Invoice Format"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            <Accordion allowMultiple defaultIndex={[0]}>
                {invoiceFormatList?.map(({ title, contents }) => (
                    <AccordionItem key={title}>
                        <AccordionButton>
                            <Box flex="1" textAlign="left" fontWeight="bold">
                                {title}
                            </Box>
                            {/* <Button
                                size="sm"
                                ml={2}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    // handleRestoreDefault(title, contents);
                                }}>
                                Restore Default
                            </Button> */}
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4}>
                            <Stack spacing={3}>
                                {contents?.map((item) => (
                                    <InvoiceFormatFields
                                        key={item.format.label}
                                        globalCursorPosition={
                                            globalCursorPosition
                                        }
                                        billingState={billingState}
                                        setBillingState={setBillingState}
                                        setGlobalCursorPosition={
                                            setGlobalCursorPosition
                                        }
                                        {...item}
                                    />
                                ))}
                            </Stack>
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </AccordionItemHandler>
    );
};

export default CompanyBillingInvoiceFormat;
